const NAVBAR_MENU_PERMISSIONS = {
  1000001: 'Dashboard',
  1000002: 'Doc Store',
  1000003: 'Contact Us',
};

export const PAGE_ACCESS_IDS = {
  DASHBOARD: 1000001,
  DASHBOARD_SYSTEM_ANALYSIS: 1000101,
  DASHBOARD_PIPE_ANALYSIS: 1000102,
  DASHBOARD_PSM: 1000103,
  DASHBOARD_AMMONIA_INVENTORY: 1000104,
  DASHBOARD_TASKS: 1000105,

  DOC_STORE: 1000002,
  DOC_STORE_PNID: 1000201,
  DOC_STORE_ENGINEERING_DRAWINGS: 1000202,
  DOC_STORE_LAD: 1000203,
  DOC_STORE_MEB: 1000204,
  DOC_STORE_MASTER_LIST: 1000205,
  DOC_STORE_REPORTS: 1000206,
  DOC_STORE_USER_FILES: 1000207,

  CONTACT_US: 1000003,
};


export default NAVBAR_MENU_PERMISSIONS;
